import React, { useState } from 'react';
import './styles.css';

const BasicTooltip = props => {
  const { tooltip, children } = props;
  const [hover, setHover] = useState(false);

  const hoverOn = () => {
    setHover(true);
  };

  const hoverOff = () => {
    setHover(false);
  };

  return (
    <div
      className="basic-tooltip"
      onMouseEnter={hoverOn}
      onMouseLeave={hoverOff}
      onMouseOver={hoverOn}
      onMouseOut={hoverOff}
      onMouseUp={hoverOn}
      onMouseDown={hoverOff}
      onFocus={hoverOn}
      onBlur={hoverOff}
    >
      {children}
      {hover && (
        <div className="basic-tooltip__popup">
          <div className="basic-tooltip__content">{tooltip}</div>
        </div>
      )}
    </div>
  );
};

export default BasicTooltip;
